<template>
  <dialog-edit
    v-if="business.id"
    :icon="icon"
    :to="redirect"
    :title="title"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-businesses-edit
        :item="business"
        :is-loading="isLoading"
        :on-cancel="onCancel"
        :on-submit="$ability.can('update', 'business') ? updateBusiness : undefined"
      />
    </template>
  </dialog-edit>
</template>

<script>
  import { isObj } from '@/utils';

  export default {
    data() {
      return {
        business: {},
        isLoading: false,
      };
    },
    computed: {
      redirect() {
        return `/businesses/${this.business.id}`;
      },
      title() {
        const { business, isBlocked } = this;
        return isBlocked ? `${business.name} (${this.$t('blocked')})` : business.name;
      },
      icon() {
        return this.isBlocked ? 'cancel' : 'business_center';
      },
      isBlocked() {
        const { status } = this.business;
        return isObj(status) && status.name.toLowerCase() === 'blocked';
      },
    },
    created() {
      this.getBusiness(this.$route.params.id);
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'businesses' });
      },
      getBusiness(id) {
        this.isLoading = true;
        return this.$store
          .dispatch('businesses/getItem', { id })
          .then(() => {
            this.business = this.$store.getters['businesses/activeItem'];
            this.isLoading = false;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      updateBusiness(business) {
        const nextBusiness = { ...business, id: this.business.id };

        this.isLoading = true;
        return this.$store
          .dispatch('businesses/update', nextBusiness)
          .then(() => {
            return this.getBusiness(this.business.id);
          })
          .catch((err) => err)
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
  };
</script>
